import { render } from "./company.vue?vue&type=template&id=55967aab&scoped=true"
import script from "./company.vue?vue&type=script&lang=js"
export * from "./company.vue?vue&type=script&lang=js"

import "./company.vue?vue&type=style&index=0&id=55967aab&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-55967aab"

export default script